/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Alert, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICookieComplianceViewProps } from './dobbies-cookie-compliance';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';

const CookieComplianceView: React.FC<ICookieComplianceViewProps> = props => {
    const { CookieComplianceBanner, AlertProps, Content, acceptButton, text, checkboxes } = props;

    // const [isModalOpen, setIsModalOpen] = React.useState(false);
    const onCookieCloseClicked = () => {
        const cookieContainer = document.getElementById('cookieBanner');
        if (cookieContainer) {
            if (cookieContainer.classList.contains('d-none')) {
                cookieContainer.classList.remove('d-none');
            } else {
                cookieContainer.classList.add('d-none');
            }
        }
    };
    const onModalCloseClicked = () => {
        // setIsModalOpen(false);
        if (props.onManageCookiesModalClose) {
            props.onManageCookiesModalClose();
        }
    };

    const openModal = () => {
        // setIsModalOpen(true);
        if (props.onManageCookiesClicked) {
            props.onManageCookiesClicked();
        }
    };

    return (
        <>
            {props.isModuleVisible ? (
                <Module {...CookieComplianceBanner}>
                    <Alert className={AlertProps.className} color={AlertProps.color} fade={AlertProps.fade}>
                        <button
                            id='closeCookie'
                            className='ms-cookie-compliance__close'
                            aria-label='Close cookie banner'
                            onClick={onCookieCloseClicked}
                        ></button>
                        <Node {...Content}>{text}</Node>
                        <div className='ms-cookie-compliance__cta'>
                            <button
                                className='link'
                                onClick={() => {
                                    openModal();
                                }}
                            >
                                Manage cookies
                            </button>
                            <button
                                className='msc-btn ms-cookie-compliance__accept-button reject-button'
                                onClick={() => {
                                    if (props.onRejectAll) {
                                        props.onRejectAll();
                                    }
                                }}
                            >
                                Reject all cookies
                            </button>
                            {acceptButton}
                        </div>
                    </Alert>
                </Module>
            ) : (
                <></>
            )}
            <Modal isOpen={props.showModal} toggle={onModalCloseClicked} className='cookie-modal'>
                <ModalHeader toggle={onModalCloseClicked} className=''></ModalHeader>
                <ModalBody className=''>
                    <div className='cookie-modal_head'>
                        <h2>Manage cookies</h2>
                    </div>
                    <div className='cookie-modal__cta'>
                        <button
                            className='ms-cookie-compliance__accept-button reject-button msc-btn'
                            onClick={() => {
                                if (props.onRejectAll) {
                                    props.onRejectAll();
                                }
                            }}
                        >
                            Reject all cookies
                        </button>
                        {acceptButton}
                    </div>
                    <div className='cookie-modal__description'>
                        <p>
                            A cookie is a small text file that is downloaded on to a computer or smartphone when the user accesses a
                            website. It allows the website to recognise that user’s device and store some information about the user’s
                            preferences or past actions<span>.</span> <div></div> Our website uses cookies to distinguish you from other
                            users of our website. This helps us to provide you with a good experience when you browse our website, while
                            also allowing us to improve our site. You can choose to reject cookies or manage your access below and full
                            details can be found on our <a href='/privacy-and-cookie-policy'>privacy and cookie policy page</a>
                        </p>
                    </div>
                    <div className='cookie-modal__checkboxes'>
                        <h3>We use the following types of cookies:</h3>
                        {checkboxes}
                    </div>
                    <div className='cookie-modal__save-settings'>
                        <button
                            onClick={() => {
                                if (props.onSaveSettings) {
                                    props.onSaveSettings();
                                }
                            }}
                        >
                            Save settings
                        </button>
                    </div>
                </ModalBody>
                <ModalFooter className='' />
            </Modal>
        </>
    );
};
export default CookieComplianceView;
